// extracted by mini-css-extract-plugin
module.exports = {"productListWrapper":"ProductListView_productListWrapper__Q9ki_"};